var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [_vm._v("Need seamless access to registry documents?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Many African markets are ill-equipped to meet global diligence requirements without having boots on the ground. Our corporate document retrieval service combines our on-the-ground presence with the tech to feed you the digitised date you need.\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openLink },
          },
          [_vm._v("Compliance Support")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }